export default "__VITE_ASSET__pcd67sbZ__"